import React from 'react';
import Badge from '../components/Badge';
import keyIcon from '../icons/non-prefilled/16x16/key.svg';

const AdminBadge = () => (
  <Badge inline={false} color="blue" icon={<Badge.Icon>{keyIcon}</Badge.Icon>}>
    ADMIN
  </Badge>
);

export default AdminBadge;
